export default __webpack_public_path__ + "static/media/AdobeStock_305638970.680e2887.jpg";